module.exports = __webpack_public_path__ + "static/js/0.a0bbbe32.chunk.worker.js"